export class ISearchable {
  constructor() {
    if (this.formatToDisplay === undefined) {
      throw new Error('Must implement formatToDisplay method')
    }
    if (this.formatToCreate === undefined) {
      throw new Error('Must implement formatToCreate method')
    }
    if (this.getIdAttribute === undefined) {
      throw new Error('Must implement getIdAttribute method')
    }
    if (this.getNameAttribute === undefined) {
      throw new Error('Must implement getNameAttribute method')
    }
    if (this.getRaccourciAttribute === undefined) {
      throw new Error('Must implement getRaccourciAttribute method')
    }
  }
}
